const getBlackbox = () => {
  const IGLOO = window.IGLOO
  if (IGLOO && typeof IGLOO.getBlackbox === 'function') {
    return IGLOO.getBlackbox().blackbox
  }
  return null
}

export default getBlackbox
